import { Box, Container, Stack, Typography } from '@mui/material';
import { useT } from '../../i18n';

const STEPS = ['landing.how.s1', 'landing.how.s2', 'landing.how.s3'];

export function HowItWorks() {
  const t = useT();

  return (
    <Box component="section" sx={{ bgcolor: 'background.paper', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Typography variant="h3" fontWeight={700} sx={{ letterSpacing: '-0.3px' }}>
          {t('landing.how.title')}
        </Typography>
        <Box
          sx={{
            mt: 4,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
            gap: 3,
          }}
        >
          {STEPS.map((key, i) => (
            <Stack key={key} spacing={1.5}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  bgcolor: 'secondary.main',
                  color: 'secondary.contrastText',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 600,
                }}
              >
                {i + 1}
              </Box>
              <Typography variant="body1" color="text.secondary">
                {t(key)}
              </Typography>
            </Stack>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
